'use client'

import { useQuery } from '@tanstack/react-query'
import { getCurrentPlanData, getPlansDataFromStripe } from '.'

export const useCurrentPlanData = (
  teamId: string | undefined | null,
  plan: string | undefined | null
) => {
  const currentPlanDetails = useQuery({
    queryFn: () => getCurrentPlanData(teamId!),
    queryKey: ['subscription-details', teamId, plan],
    enabled: !!teamId && !!plan,
  })

  return currentPlanDetails
}

export const usePlansData = () => {
  const plansData = useQuery({
    queryFn: () => getPlansDataFromStripe(),
    queryKey: ['plans'],
  })

  return plansData
}
